<template>
    <div v-if="showModal" class="fixed inset-0 flex items-center justify-center z-[99999]">
      <div class="fixed inset-0 bg-gray-900 opacity-75"></div>
      <div class="bg-white p-4 rounded-lg z-10 shadow-md">
        <p class="text-xl font-semibold">{{modalTitle}}</p>
        <p>{{ modalMessage }}</p>
        <button @click="closeModal" class="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
          Close
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'modal-alert',
    props: {
      showModal: Boolean,
      modalTitle: String,
      modalMessage: String,
    },
    methods: {
      closeModal() {
        this.$emit('close-modal'); // Emit a custom event to close the modal
      },
    },
  };
  </script>
  